import { FC } from 'react';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { MuiTrackerButton } from './TrackerButtonWrapper';

type KeyProps = {
  value: string;
  onKeyClick: (value: string) => void;
};

const Key: FC<KeyProps> = ({ value, onKeyClick }) => {
  return (
    <MuiTrackerButton
      buttonName={`${value}-key`}
      color="primary"
      variant="key"
      onClick={() => {
        onKeyClick(value);
      }}
      data-testid={`key-${value}`}
    >
      {value === 'delete' ? <BackspaceOutlinedIcon /> : value}
    </MuiTrackerButton>
  );
};
export default Key;
